module.exports = __webpack_public_path__ + "static/media/pretoria-news.b7dcb9a4.svg";